export default __webpack_public_path__ + "static/media/21.2a15fce4.jpg";